import {Component} from 'react';
import TitleLegalDescription from './TitleLegalDescription';
import PropTypes from 'prop-types';

export default class TitleLegalDescriptions extends Component {
  static propTypes = {
    className: PropTypes.string,
    legalDescriptions: PropTypes.array,
  };

  render() {
    const {className, legalDescriptions} = this.props;
    const classNames = ['title-legal-descriptions', className].join(' ').trim();
    return (
      <div className={classNames}>
        {legalDescriptions.map((l, i) => (
          <TitleLegalDescription key={i} legalDescription={l}/>))
        }
      </div>
    );
  }
}